<template>
  <div class="InsuranceDetail">
    <div class="header">
      <p class="caption">{{ coverage.headerTitle }}</p>
      <h1 class="gl_form-title secondary">{{ coverage.label }}</h1>
    </div>

    <CardInfoComponent v-if="coverage.message">
      {{ coverage.message }}
    </CardInfoComponent>

    <ProductInfoComponent
      :type="coverage.code"
      :features="coverage.highlights"
    />

    <template v-if="coverage">
      <template
        v-for="section in coverage.sections"
        :key="section.id"
      >
        <AccordionComponent
          v-if="section.items.length > 0"
          :title="section.title"
        >
          <AccordionContentComponent
            :key="section.id"
            :accordion="section"
          />
        </AccordionComponent>
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import AccordionContentComponent from '@/modules/common/common/components/insuranceAccordions/AccordionContentComponent.vue'
import AccordionComponent from '@/modules/core/components/utils/AccordionComponent.vue'
import ProductInfoComponent from '@/modules/common/common/components/panels/ProductInfoComponent.vue'
import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'

import AdditionalCoverageConfig from '@/modules/health/hiring/models/APP/AdditionalCoverageConfig'

interface PropsInterface {
  coverage: AdditionalCoverageConfig
}

defineProps<PropsInterface>()
</script>

<style lang="scss" scoped>
.InsuranceDetail {
  max-width: $size-375;
  margin: 0 auto;
  position: relative;
  padding-bottom: $spacing-2xl;

  @include breakpoint-lg {
    max-width: $size-1200;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: $spacing-l 0;

    h1 {
      text-align: center;
    }

    .caption {
      text-align: center;
      color: $color-neutral;
      font-size: $font-size-s;
    }

    .title {
      font-family: $font-family-secondary;
      font-size: $font-size-2xl;
    }
  }

  /*   .accordions {
    max-width: $size-700;
    margin: 0 auto;

    .AccordionComponent:not(:last-child) :deep(.v-expansion-panel-title) {
      @include breakpoint-lg {
        &::after {
          content: '';
          height: $size-01;
          width: calc(100% - 3rem);
          margin: 0 auto;
          position: absolute;
          bottom: 0;
          background-color: $color-neutral-light;
        }
      }
    }

    h2 {
      text-align: center;
      margin-bottom: $spacing-2xl;
      color: $color-primary;
    }

    h3 {
      color: $color-primary;
    }
  } */
  :deep(.ChecksComponent) {
    .row {
      height: unset;
    }
  }

  :deep(.SimplesComponent) {
    .row {
      height: unset;
    }
  }
}
</style>
